module.exports = __webpack_public_path__ + "media/images/a7-bab8785e814db9dab8beed4bab64fd98.jpg";